import { render, staticRenderFns } from "./destinationDetails.vue?vue&type=template&id=310d1efa"
import script from "./destinationDetails.vue?vue&type=script&lang=js"
export * from "./destinationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports